import type { FunctionComponent } from 'react';

import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
import { useLastWinDisplayConnected } from '@pp/core/src/components/game/wallet/lastWin/useLastWinDisplayConnected';
import { LastWinValueConnected } from '@pp/core/src/components/game/wallet/values/LastWinValueConnected';
import { TotalBetValueConnected } from '@pp/core/src/components/game/wallet/values/TotalBetValueConnected';
import { useTrophy } from '@pp/core/src/hooks/helpers/useTrophy';
import { useNetPositionConnected } from '@pp/core/src/hooks/useNetPositionConnected';
import { useIsLargerThanWide } from '@pp/core/src/styles/hooks/media';

import { useHighflyerStateSlice } from '../../../store/slices/highflyerState/selectors';
import { TotalBetWing } from '../totalBetWing/TotalBetWing';

export const TotalBetWingConnected: FunctionComponent = () => {
  const net = useNetPositionConnected();

  const trophy = useTrophy();
  const inDesktopMode = useIsLargerThanWide();
  const hasAnyEarlyBets = useHighflyerStateSlice.hasAnyEarlyBets();
  const lastWin = hasAnyEarlyBets ? 0 : useLastWinDisplayConnected();
  return (
    <TotalBetWing
      trophy={trophy}
      totalBet={lastWin ? <LastWinValueConnected value={lastWin} /> : <TotalBetValueConnected />}
      netPosition={net !== undefined && inDesktopMode && <CurrencyConnected value={net} />}
      lastWin={lastWin}
    />
  );
};
